import Mouse from "./mouse";

const mouse = new Mouse();
const Input = new class Input extends THREE.EventDispatcher {
    constructor() {
        super();
    }

    get mouse() { return mouse; }
}

export default Input;
export { Input };